import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Expertise } from './pages/Expertise';
import { Industries } from './pages/Industries';
import { Employers } from './pages/Employers';
import { Candidates } from './pages/Candidates';
import { Opportunities } from './pages/Opportunities';
import { Insights } from './pages/Insights';
import { InsightArticle } from './pages/InsightArticle';
import { Contact } from './pages/Contact';
import { NotFound } from './pages/NotFound';
import { consultantLegacyPaths } from './data/navigation';
import { isFeatureEnabled } from './utils/features';
export function App() {
  const consultantsEnabled = isFeatureEnabled('consultants');
  return <BrowserRouter data-id="element-0" data-mp="28sbbx5a2f776">
      <Routes data-id="element-1" data-mp="23vchsmqej08z">
        <Route element={<Layout data-id="element-3" data-mp="23w4clvc6cty7" />} data-id="element-2" data-mp="23vune9yyeqtk">
          <Route index element={<Home data-id="element-5" data-mp="23t8iki3g6pf1" />} data-id="element-4" data-mp="23utcq6luo6cd" />
          <Route path="about" element={<About data-id="element-7" data-mp="3ikqy1x7ax04o" />} data-id="element-6" data-mp="3ijxokogyjwiu" />
          <Route path="expertise" element={<Expertise data-id="element-9" data-mp="3ii4sg33z0up3" />} data-id="element-8" data-mp="3ij61k21ff746" />
          <Route path="industries" element={<Industries data-id="element-11" data-mp="3mk852v2dm5by" />} data-id="element-10" data-mp="3ml14tc2x3ukl" />
          <Route path="employers" element={<Employers data-id="element-13" data-mp="3rcj8i7wbs999" />} data-id="element-12" data-mp="3mjga9mglsbmq" />
          <Route path="candidates" element={<Candidates data-id="element-15" data-mp="3rd189ei755lx" />} data-id="element-14" data-mp="3rdas0kcnegj6" />
          <Route path="opportunities" element={<Opportunities data-id="element-17" data-mp="4wxfu7a14id" />} data-id="element-16" data-mp="5yhgo69t1c8" />
          <Route path="insights" element={<Insights data-id="element-19" data-mp="2zl3cxocsjc6w" />} data-id="element-18" data-mp="56l3b4umzkw" />
          <Route path="insights/:slug" element={<InsightArticle data-id="element-21" data-mp="2zmwit1fkxsdu" />} data-id="element-20" data-mp="2zlv7qwykd5w4" />
          <Route path="contact" element={<Contact data-id="element-23" data-mp="33lx0ggmbmoz9" />} data-id="element-22" data-mp="33mowttnqsqql" />

          {/*
            Consultants section is temporarily switched off (data/siteConfig.ts).
            When enabling it, add the consultants list + profile routes here
            (e.g. "consultants" and "consultants/:slug") backed by data/consultants.ts.
           */}
          {!consultantsEnabled && consultantLegacyPaths.map(path => <Route key={path} path={path} element={<Navigate to="/contact" replace data-id="element-25" data-mp="stc8y6r794oy" />} data-id="element-24" data-mp="sudl6ejybx89" />)}

          <Route path="*" element={<NotFound data-id="element-27" data-mp="35yngfn0fdzc" />} data-id="element-26" data-mp="36hxla6f4y2t" />
        </Route>
      </Routes>
    </BrowserRouter>;
}